//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'open-item',
  props: {
    label: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      opened: false
    };
  },
  methods: {
    toggleOpen: function toggleOpen() {
      this.opened = !this.opened;
    }
  }
};